/**
 * Placeholder slides, as in the mobile app: the Fantasy15 copy is not written yet, so each slide is a
 * title over the matching Goal Rush illustration. Add descriptions here once the copy exists.
 */
export interface Fantasy15HowItWorksSlide {
  readonly title: string;
  readonly img: string;
}

export const FANTASY15_HOW_IT_WORKS_SLIDES: readonly Fantasy15HowItWorksSlide[] = [
  {
    title: 'How Fantasy Works',
    img: '/assets/slides/howToWin/goal_rush/slide1.jpg',
  },
  {
    title: 'Building Your Card',
    img: '/assets/slides/howToWin/goal_rush/slide2.jpg',
  },
  {
    title: 'Scoring & Leaderboard',
    img: '/assets/slides/howToWin/goal_rush/slide3.jpg',
  },
  {
    title: 'Tournament Fantasy15: NUDGE',
    img: '/assets/slides/howToWin/goal_rush/slide4.jpg',
  },
];
